import React from 'react';


const About = () => {
    return (
      <div>
         <div className="slider-area ">
            <div className="single-slider slider-height2 d-flex align-items-center">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="hero-cap text-center">
                                <h2>About Us</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
      
        <div className="about-details section-padding30">
            <div className="container">
                <div className="row">
                    <div className="offset-xl-1 col-lg-8">
                        <div className="about-details-cap mb-50">
                            <h2>Our Story</h2>
                            <p> Asian Watch Shop’s Start  up in bangladeshi company in 2021 , when Sham Naib founded the jewellery retailer SDK Jewellers in the town which is still WatchShop’s home, Reading in Berkshire. When Sham’s son, Kishore Naib, joined the business in 2007, he established the website Watchshop.co.uk. Our official founding! The Naib family proudly sold the business in 2014, and we have since grown into the biggest independent watch retailer in the UK.
                            </p>
                            <p> Risus commodo viverra sebfd dho eiusmod tempor maecenas accumsan lacus. Risus commodo viverra sebfd dho eiusmod tempor maecenas accumsan.</p>
                        </div>

                        <div className="about-details-cap mb-50">
                            <h2>Our Brands </h2>
                            <p>Here at WatchShop, we pride ourselves on being the No. 1 for Brands in the designer watch world. Stocking over 150 top brands, from luxury Versace to hip HUGO, plus brands designed by us such as Depth Charge (available exclusively at WatchShop, we might add), we are here to help you find your ideal watch, whoever you are buying for.

On top of our impressive brand collection, our buyers work hard to secure exclusive lines from a curation of our bestselling brands; the brands most loved by you. We love giving you, our customers, the VIP treatment by offering standout exclusives from the likes of Rotary, Guess and STORM London.
                            </p>
                            
                          
                        </div>
                        <div className="about-details-cap mb-50">
                            <h2>Our Promise to You </h2>
                            <p>

                            Wondering whether our watches are genuine, considering how good the prices are? No need to worry; we are official stockists for all of our brands*. Your watch will ship out of our very own warehouse in Reading, and before then, it will sit with the official manufacturer. No middle man here! This also means every watch you purchase with us will come in the original brand packaging and with a valid guarantee. Plus any extras, such as instructions and technical information (if applicable), will be present and correct.
                            </p>
                            
                          
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
       
        
    );
};

export default About;